import styled from "styled-components";

export const BackgroundContainer = styled("section")`
  min-height:100vh;
`;

